'use client';

export { Card, type CardProps } from '@paypoteam/ui-components';
